import { Flex, Tabs } from 'antd'
import React, { createElement, ReactNode, useCallback, useEffect, useState } from 'react'

import Page from '@/components/shared/page'
import { FeatureKey } from '@/constants/feature-key'
import { setFeatureKeys } from '@/redux/global'
import { useAppDispatch } from '@/redux/utils'

import ChatterReportsOverview from './chatter-reports-overview'
import ChatterReportsPerformance from './chatter-reports-performance'
import s from './chatter-reports.module.css'
import {
  ReportsPageProps,
  useReportSearch,
} from './hooks/use-report-search'

const tabPagesConfig: Record<string, (props: ReportsPageProps) => ReactNode> = {
  [FeatureKey.ChatterReportsOverview]: ChatterReportsOverview,
  [FeatureKey.ChattersPerformance]: ChatterReportsPerformance,
}

const tabItems = [
  { key: FeatureKey.ChatterReportsOverview, label: 'Overview' },
  { key: FeatureKey.ChattersPerformance, label: 'Chatter performance' },
]

export default function ChatterReportsPage() {
  const [currentMenuKey, setCurrentMenuKey] = useState(tabItems[0].key)
  const { searchValues, searchElements } = useReportSearch({
    enableEmployeesFilter: currentMenuKey === FeatureKey.ChatterReportsOverview,
  })
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setFeatureKeys([FeatureKey.Analytics, FeatureKey.ChatterReports, currentMenuKey]))
  }, [currentMenuKey, dispatch])

  const onTabChange = useCallback((activeKey: string) => {
    setCurrentMenuKey(activeKey as FeatureKey)
  }, [])

  return (
    <Page contentClassName={s.chatterReportsContent}>
      <Tabs
        className={s.tabs}
        tabBarExtraContent={searchElements}
        items={tabItems}
        activeKey={currentMenuKey}
        onChange={onTabChange}
      />
      <Flex vertical className={s.tabContent}>
        {createElement(tabPagesConfig[currentMenuKey], {
          searchValues,
        })}
      </Flex>
    </Page>
  )
}
